import bwipjs from 'bwip-js';
import { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Heading, Pane } from 'evergreen-ui';
import { addOrderActivity, confirmOrderPayment, deleteOrder, getOrder, updateOrderStatus } from '../actions/OrderActions';

import { Link } from 'react-router-dom';
import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import OrderInfoBlock from '../components/OrderInfoBlock';
import OrderFlagBanner from '../components/OrderFlagBanner';
import { TicketsModal } from '../../../v2/features/tickets/components/EntityTickets';
import { TicketFormDialog } from '../../../v2/features/tickets/components/TicketFormDialog';
import { printOrderSticker } from '../printOrderSticker';

class ViewOrder extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
        this.state = { threadsOpen: false, newTicketOpen: false };
    }

    componentDidMount() {
        this.props.dispatch(getOrder(this.id))
    }

    componentDidUpdate(prevProps) {
        if (this.props.order && this.props.order.orderNumber &&
            (!prevProps.order || prevProps.order.orderNumber !== this.props.order.orderNumber)) {
            try {
                const canvas = document.getElementById(`qr-order-${this.props.order.orderNumber}`);
                if (canvas) {
                    bwipjs.toCanvas(canvas, {
                        bcid: 'qrcode',
                        text: 'order:load:' + this.props.order.orderNumber.toString(),
                        scale: 3,
                        height: 7,
                        width: 7,
                        includetext: true
                    });
                }
            } catch (error) {
                console.error('Error generating QR code:', error);
            }
        }
    }

    handleDelete = () => {
        this.props.dispatch(deleteOrder(this.id));
    }

    handleUpdateOrderStatus = (status, values, force = false) => {
        if(status === this.props.order.status && status !== 'returned' && status !== 'processed') {
            return;
        }
        return this.props.dispatch(updateOrderStatus(this.id, status, values, force))
    }

    handleAddActivity = async (activity) => {
        this.props.dispatch(addOrderActivity(this.id, activity));
    }

    handleConfirmOrderPayment = (status) => {
        this.props.dispatch(confirmOrderPayment(this.id, status));
    }

    render() {
        const orderId = this.props.order && this.props.order.id;
        const hasIssues = !!(this.props.order && this.props.order.issues > 0);
        const target = orderId
            ? { targetType: 'order', targetId: orderId, label: `Comanda #${this.props.order.orderNumber}` }
            : null;

        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/orders">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista comenzi
                            </Button>
                        </Link>
                    </Pane>

                    <Pane marginLeft={16} alignSelf="flex-end">
                        <Button
                            iconBefore={hasIssues ? 'warning-sign' : 'comment'}
                            intent={hasIssues ? 'warning' : 'none'}
                            appearance={hasIssues ? 'primary' : 'default'}
                            disabled={!orderId}
                            onClick={() => this.setState({ threadsOpen: true })}>
                            Tickete{hasIssues ? ` (${this.props.order.issues})` : ''}
                        </Button>
                    </Pane>

                    <Pane marginLeft={16} alignSelf="flex-end">
                        <Button
                            iconBefore="plus"
                            disabled={!orderId}
                            onClick={() => this.setState({ newTicketOpen: true })}>
                            Ticket nou
                        </Button>
                    </Pane>

                    <Pane marginLeft={16} alignSelf="flex-end">
                        <Button
                            iconBefore="print"
                            disabled={!orderId}
                            onClick={() => printOrderSticker(this.props.order)}>
                            Printeaza eticheta
                        </Button>
                    </Pane>

                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge comanda"
                            title="Confirmare stergere comanda"
                            confirmLabel="Sterg definitiv comanda"
                            message="Esti sigur ca vrei sa stergi comanda?"/>
                    </Pane>
                </Pane>

                <TicketsModal
                    target={this.state.threadsOpen ? target : null}
                    onClose={() => this.setState({ threadsOpen: false })}
                />

                {/* Direct create — the ticket is born linked to this order. */}
                {target && (
                    <TicketFormDialog
                        open={this.state.newTicketOpen}
                        onOpenChange={(open) => this.setState({ newTicketOpen: open })}
                        ticket={null}
                        initialRefs={[{ itemType: 'order', itemId: String(target.targetId), label: target.label }]}
                    />
                )}

                <OrderFlagBanner order={this.props.order} />

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16} display="flex" alignItems="center" justifyContent="space-between">
                    <Heading size={600}>
                        Comanda - <strong>#{this.props.order.orderNumber}</strong> (ID: {this.props.order.id})
                    </Heading>
                    <Pane display="flex" flexDirection="column" alignItems="center">
                        <Pane
                            padding={2}
                            background="white"
                            borderRadius={4}
                            border="1px solid #E4E7EB"
                        >
                            <canvas id={`qr-order-${this.props.order.orderNumber}`} />
                        </Pane>
                    </Pane>
                </Pane>

                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16} width="100%">
                    <OrderInfoBlock order={this.props.order}
                        isAdmin={this.props.isAdmin}
                        onAddActivity={this.handleAddActivity}
                        onOpenIssues={() => this.setState({ threadsOpen: true })}
                        updateOrderStatus={this.handleUpdateOrderStatus}
                        confirmOrderPayment={this.handleConfirmOrderPayment}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    const user = state.authentication.user;
    return {
        order: state.orders.current,
        isAdmin: !!(user && user.role && user.role.level >= 3)
    }
}

export default connect(mapStateToProps)(ViewOrder);
